import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// CRM campaign status — reads the read-only Admin_CRM_CampaignStatus proc via the
// Store WebAPI. Same token-refresh pattern as rto3service.
export default class CRMCampaignService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getStatus(isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CRM_CAMPAIGN_STATUS });
    let out = {};
    await api.endpoints[this.endpoint.GET_CRM_CAMPAIGN_STATUS]
      .getAllPost({})
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getStatus(true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
